import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateDefaultAddressInput,
    DefaultAddress,
    UpdateDefaultAddressInput
} from '../../services/api/API';
@Injectable({
    providedIn: 'root'
})
export class DefaultAddressService {
    private amplifyClient = generateClient();
    constructor() {}

    async listDefaultAddresses(): Promise<DefaultAddress[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listDefaultAddresses
                })
            ).data.listDefaultAddresses.items;
            if (data) return data as DefaultAddress[];
        } catch (error) {
            console.error('Error finding DefaultAddress:', error);
            return null;
        }
    }

    async defaultAddressByCompanyId(
        companyId: string
    ): Promise<DefaultAddress[]> {
        try {
            const result = await this.amplifyClient.graphql({
                query: queries.DefaultAddressByCompanyId,
                variables: {
                    companyId
                }
            });
            const data = result.data.DefaultAddressByCompanyId.items;

            // Ensure data is defined and return it as DefaultAddress array
            return Array.isArray(data) ? (data as DefaultAddress[]) : [];
        } catch (error) {
            console.error('Error finding DefaultAddress:', error);
            return [];
        }
    }

    async defaultAddressByUserId(userId: string): Promise<DefaultAddress[]> {
        try {
            const result = await this.amplifyClient.graphql({
                query: queries.DefaultAddressByUserId,
                variables: { userId }
            });
            const data = result.data.DefaultAddressByUserId.items;
            return Array.isArray(data) ? (data as DefaultAddress[]) : [];
        } catch (error) {
            console.error('Error finding DefaultAddress by userId:', error);
            return [];
        }
    }

    async createDefaultAddress(
        input: CreateDefaultAddressInput
    ): Promise<DefaultAddress> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createDefaultAddress,
                    variables: {
                        input
                    }
                })
            ).data.createDefaultAddress;
            if (data) return data as DefaultAddress;
        } catch (error) {
            console.error('Error creating BuyerContactsRFQPrinted:', error);
            return null;
        }
    }
    async updateDefaultAddress(
        input: UpdateDefaultAddressInput
    ): Promise<DefaultAddress> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateDefaultAddress,
                    variables: {
                        input
                    }
                })
            ).data.updateDefaultAddress;
            if (data) return data as DefaultAddress;
        } catch (error) {
            console.error('Error updated BuyerContactsRFQPrinted:', error);
            return null;
        }
    }

    async listAllDefaultAddressesByCompanyId(
        companyId: string,
        pageLimit: number = 10
    ): Promise<DefaultAddress[]> {
        const addresses: DefaultAddress[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.DefaultAddressByCompanyId,
                        variables: {
                            companyId,
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.DefaultAddressByCompanyId;
                addresses.push(
                    ...((response?.items ?? []) as DefaultAddress[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return addresses;
        } catch (error) {
            console.error('Error finding DefaultAddress:', error);
            return [];
        }
    }

    async deleteDefaultAddress(id: string): Promise<boolean> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteDefaultAddress,
                    variables: {
                        input: { id }
                    }
                })
            ).data.deleteDefaultAddress;

            return !!data;
        } catch (error) {
            console.error('Error deleting DefaultAddress:', error);
            return false;
        }
    }
}
